import { Component } from '@angular/core';

@Component({
    selector: 'roleBasedRouting',
    template: `<router-outlet></router-outlet>`,
    standalone: false
})
export class RoleBasedRouting {
    constructor() { }

}
